import { useCallback, useEffect, useState } from "react";
import { getAnchorEntitlements, hasAnyAnchor } from "@/lib/entitlements/anchorsClient";
import { useScopedOrganizationId } from "@/contexts/WorkspaceOrgContext";

/** Anchor-layer gate for Service bucket panels (embedded layer — any anchor). */
export function useServiceAnchorLayerGate() {
  const scopedOrganizationId = useScopedOrganizationId();
  const [loading, setLoading] = useState(true);
  const [working, setWorking] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async (opts?: { refresh?: boolean }) => {
    if (opts?.refresh) setWorking(true);
    else setLoading(true);
    setError(null);

    const res = await getAnchorEntitlements();
    if (!res.ok) {
      setEnabled(false);
      setError(res.error);
      setLoading(false);
      setWorking(false);
      return;
    }
    setEnabled(hasAnyAnchor(res.data.anchors));
    setLoading(false);
    setWorking(false);
  }, []);

  useEffect(() => {
    void load();
  }, [load, scopedOrganizationId]);

  return {
    loading,
    working,
    enabled,
    error,
    scopedOrganizationId,
    refresh: () => void load({ refresh: true }),
  };
}
